import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import $ from 'jquery';
import {CREATE_MESSAGE} from '../company/jobs/apis';

export default function MessageFooter(props){
    const [sendMessage, { loading  , data }] = useMutation(CREATE_MESSAGE);
    $(document).ready(function() {
        $(window).keydown(function(event){
          if(event.keyCode == 13) {
            return true;
          }
        });
      });
    const handleSubmit =(e)=>{
        e.preventDefault();
        let inputValue = e.target.querySelector('#input-message').value;
        if(inputValue){
            const userAuth = JSON.parse(localStorage.getItem('jwt'))?.user;
            // in case the user is a company
            if (userAuth.company) {
                //show the data of user in chat
                sendMessage({ variables: { user_id: props.sendTo , text: inputValue } });

            }
            else {
                sendMessage({ variables: { company_id: props.sendTo , text: inputValue } });

            }
            e.target.querySelector('#input-message').value = '';
            props.getData();
        }
    }
    if(!props.sendTo){
        return(<></>)
    }
    else{
        return(
            <form onSubmit={e=>handleSubmit(e)} className="bg-white row m-0 border-top">
                <section className="col-md-10 col-9 ">
                    <input type="text"id="input-message"  className="input-message bg-transparent border-0 w-100 p-2" placeholder="write a message" />
                </section>
                <section className="col-md-2 col-3 text-right">
                    <button type="submit" className="bg-transparent border-0 text-orange p-2"  >Send</button>
                </section>
            </form>
        )
    }
}